<template>
  <section class="bg-white pt-50">
    <div class="col-md-7 ta-center ma">
      <form
        id="contactForm"
        class="contact-us-form"
        @submit.prevent="sendEmail"
      >
        <h2>{{ $t("landingPage.feedbackForm.title") }}</h2>
        <p>{{ $t("landingPage.feedbackForm.subtitle") }}</p>
        <div
          class="alert alert-success"
          id="contact-alert-success"
          style="display: none"
        >
          {{ $t("landingPage.feedbackForm.alertSuccess") }}
        </div>
        <div
          class="alert alert-danger"
          id="contact-alert-failed"
          style="display: none"
        >
          {{ $t("landingPage.feedbackForm.alertFailure") }}
        </div>
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <textarea
                name="feedback"
                rows="7"
                cols="25"
                v-bind:placeholder="$t('landingPage.feedbackForm.inputField1')"
                required="required"
                class="form-control borderSolid text-area"
                style="background: #f7f7f7"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-12">
            <div class="form-group">
              <input
                type="email"
                name="user_email"
                v-bind:placeholder="$t('landingPage.feedbackForm.inputField2')"
                required="required"
                class="form-control"
                style="background: #f7f7f7"
              />
            </div>
          </div>
        </div>

        <div class="row ta-center">
          <div class="col-sm-12 col-12 displayFlex">
            <vue-recaptcha
              class="centerAlign"
              :sitekey="siteKey"
              :loadRecaptchaScript="true"
            ></vue-recaptcha>
          </div>
        </div>

        <div>
          <input
            class="customStartButton pdlr-100"
            type="submit"
            v-bind:value="$t('feedbackForm.submitButton')"
          />
        </div>
      </form>
      <p class="form-message"></p>
    </div>
  </section>
</template>
<script>
import emailjs from "emailjs-com";
import VueRecaptcha from "vue-recaptcha";
import { setLocale } from "../services/firebase";
export default {
  name: "Feedback",
  data() {
    return {
      siteKey: process.env.VUE_APP_site_key,
    };
  },
  components: { VueRecaptcha },
  mounted() {
    setLocale();
  },
  methods: {
    sendEmail: (e) => {
      emailjs
        .sendForm(
          process.env.VUE_APP_EMAIL_SERVICE_ID,
          process.env.VUE_APP_EMAIL_TEMPLATE_ID,
          e.target,
          process.env.VUE_APP_EMAIL_USER_ID
        )
        .then(
          (result) => {
            console.log("SUCCESS!", result.status, result.text);
            window.grecaptcha.reset();
            document.getElementById("contact-alert-success").style.display =
              "block";
            setTimeout(function() {
              document.getElementById("contact-alert-success").style.display =
                "none";
            }, 3000);
            e.target.reset();
          },
          (error) => {
            console.log("FAILED...", error);
            window.grecaptcha.reset();
            document.getElementById("contact-alert-failed").style.display =
              "block";
            setTimeout(function() {
              document.getElementById("contact-alert-failed").style.display =
                "none";
            }, 3000);
          }
        );
    },
  },
};
</script>
<style scoped>
.pdlr-100 {
  padding: 10px 80px;
}
.displayFlex {
  justify-content: center;
  align-items: center;
  display: flex;
}
.borderSolid {
  border: 1px solid #ccc;
  height: 120px;
  margin-bottom: 0px;
}
.form-group {
  margin-bottom: 0px;
}
.text-area:focus {
  border-color: #6730e3;
}
</style>
